// switch — default skin module
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
    min-height: 44px;
    min-width: 44px;
    justify-content: center;
    padding: 0 8px;
  }

  :host([disabled]) {
    cursor: not-allowed;
    opacity: 0.4;
    pointer-events: none;
  }

  :host(:focus-visible),
  :host([data-focus-visible]) {
    outline: 2px solid var(--run-color-focus-ring, #2563eb);
    outline-offset: 2px;
    border-radius: 99px;
  }

  [part="base"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  [part="track"] {
    position: relative;
    display: inline-block;
    width: var(--run-switch-track-width, 40px);
    height: var(--run-switch-track-height, 20px);
    border-radius: 99px;
    background: var(--run-switch-track-background, var(--run-color-border-input-default, #cbd5e1));
    transition: background 150ms ease;
    flex-shrink: 0;
  }

  :host([checked]) [part="track"] {
    background: var(--run-switch-track-background-checked, var(--run-color-intent-primary-base, #2563eb));
  }

  :host([invalid]) [part="track"] {
    outline: 2px solid var(--run-color-intent-danger-base, #ef4444);
    outline-offset: 1px;
  }

  [part="thumb"] {
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%) translateX(0);
    width: var(--run-switch-thumb-size, 16px);
    height: var(--run-switch-thumb-size, 16px);
    border-radius: 50%;
    background: var(--run-switch-thumb-background, var(--run-color-surface-default, #ffffff));
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: transform 150ms ease;
  }

  :host([checked]) [part="thumb"] {
    transform: translateY(-50%) translateX(calc(var(--run-switch-track-width, 40px) - var(--run-switch-thumb-size, 16px) - 4px));
  }

  :host([data-reduced-motion]) [part="track"],
  :host([data-reduced-motion]) [part="thumb"] {
    transition: none;
  }
`;

export function render(host) {
  const existing = host.shadowRoot.querySelector('[part="base"]');
  if (existing) return;
  host.shadowRoot.innerHTML = `
    <span part="base" aria-hidden="true">
      <span part="track">
        <span part="thumb"></span>
      </span>
    </span>
  `;
}
